import { render, staticRenderFns } from "./PageLeft.vue?vue&type=template&id=79d6488a&scoped=true&"
import script from "./PageLeft.vue?vue&type=script&lang=js&"
export * from "./PageLeft.vue?vue&type=script&lang=js&"
import style0 from "./PageLeft.vue?vue&type=style&index=0&id=79d6488a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d6488a",
  null
  
)

export default component.exports